// extracted by mini-css-extract-plugin
export default {"main":"FollowButton_main__l2X0E","linkMain":"FollowButton_linkMain__a-7Ww"};